import { ViewSupport48Component } from "../../../components/SupportSystem/ViewReports/ViewSupport48Component";
import { HeadTitle } from "../../../components/share/HeadTitle";
import { Footer } from "../../../components/share/Footer";
import { NavbarSupportSystem } from "../../../components/share/NavbarSupportSystem";
import { OperationReport48Component } from "../../../components/SupportSystem/OperationReportForm/OperationReport48Component";
export function ViewSupport48Container() {
    const titleName =
        "แบบรายงานผลการพิจารณาอนุมัติการให้เงินช่วยเหลือหรืออุดหนุนจากกองทุนพัฒนาฝีมือแรงงาน (แบบ ชอ. 4-8)"; //ใส่ชื่อtitle ตรงนี้
    return (
        <div className="page-container bg-landing">
            <NavbarSupportSystem />
            <HeadTitle title={titleName} />
            <OperationReport48Component />
            <Footer />
        </div>
    );
}
